import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateProductCategoryMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateCoreProductCategoryInput;
}>;

export type UpdateProductCategoryMutationResult = { __typename?: 'Mutation' } & {
  updateCoreProductCategory: { __typename?: 'UpdateCoreProductCategoryPayload' } & {
    coreProductCategory?: GraphQLTypes.Maybe<
      { __typename?: 'CoreProductCategory' } & Pick<GraphQLTypes.CoreProductCategory, 'id' | 'name'>
    >;
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateProductCategoryDocument = /*#__PURE__*/ gql`
  mutation updateProductCategory($input: UpdateCoreProductCategoryInput!) {
    updateCoreProductCategory(input: $input) {
      coreProductCategory {
        id
        name
      }
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateProductCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCategoryMutation, { data, loading, error }] = useUpdateProductCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProductCategoryMutationResult, UpdateProductCategoryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateProductCategoryMutationResult, UpdateProductCategoryMutationVariables>(
    UpdateProductCategoryDocument,
    options
  );
}
export type UpdateProductCategoryMutationHookResult = ReturnType<typeof useUpdateProductCategoryMutation>;
